import { useState, useEffect } from 'react';
import { PaymentMethodsApiAdapter } from '../adapters';
import type { PaymentMethod } from '../adapters';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';

export const usePaymentMethods = () => {
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const httpClient = createHttpClient(apiClientWH);
  const paymentMethodsAdapter = new PaymentMethodsApiAdapter(httpClient);

  const loadPaymentMethods = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await paymentMethodsAdapter.getPaymentMethods();
      setPaymentMethods(data);
    } catch (err) {
      setError(
        err instanceof Error ? err.message : 'Error al cargar métodos de pago'
      );
      console.error('Error loading payment methods:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPaymentMethods();
  }, []);

  return {
    paymentMethods,
    loading,
    error,
    loadPaymentMethods,
  };
};
